<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('marketingFidelities.userLabeling')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="sticky-header" ref="optionsTopBar" style="margin-top: 20px;">
          <div class="text-right">
            <p class="d-inline-flex">
              <button class="btn add mar-rt-10"  @click.prevent="goToAdd" :title="$t('general.add')">
                <img src="/static/img/icons/add.png">
                {{$t('general.add')}}
              </button>
              <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="saveDetails" :title="$t('general.save')">
                <img src="/static/img/icons/save.png">
                {{$t('general.save')}}
              </button>
            </p>
          </div>
        </div>
        <div class="company-wrap mar-to-25">
          <div class="card location-card">
            <div class="labeling-options">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('marketingFidelities.labelingPrimaryOption')}}</label>
                    <select name="fidelities_labels_primary_option" class="form-control" v-model="labelsPrimaryOption">
                      <option
                        v-for="(opt, key) in fidelitiesOptions"
                        :value="key"
                        :selected="key === labelsPrimaryOption">{{$t('marketingFidelities.'+key)}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6" v-if="labelsPrimaryOption != 'MOR'">
                  <div class="form-group">
                    <label>{{$t('marketingFidelities.labelingInterval')}}</label>
                    <select name="fidelities_labels_interval" class="form-control" v-model="labelsInterval">
                      <option
                        v-for="(opt, key) in fidelitiesIntervalOptions"
                        :value="key"
                        :selected="key === labelsInterval">{{$t('marketingFidelities.'+key)}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <p-checkbox v-model="showLabel"><span class="pad-lf-5">{{($t('marketingFidelities.showLabelOnUser'))}}</span></p-checkbox>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <p-checkbox v-model="enableLabelNotification"><div class="pad-lf-5">{{($t('marketingFidelities.sentUserLabelNotification'))}}</div></p-checkbox>
                  </div>
                </div>
              </div>
              <div class="row">
                <a class="text-italic fidelities-customize-a" :href="'/#/info-pages'" target="_blank">{{$t('marketingFidelities.checkTermsAndConditionFidelities')}}</a>
              </div>
            </div>
          </div>
        </div>

        <div class="card mar-to-15">
          <div class="card-content">
            <data-tables
              v-loading="loading"
              :data="tableData"
              :search-def="{}"
              :pagination-def="{}"
              :table-props="{'border': false}"
              style="width: 100%">

              <!-- Define your table columns -->
              <el-table-column
                min-width="50"
                prop="name"
                :label="$t('marketingFidelities.badgeName')">
              </el-table-column>

              <el-table-column
              v-if="fidelitiesLabelsPrimaryOption == 'ordersValue'"
                min-width="50"
                prop="order_value"
                :label="$t('marketingFidelities.ordersValue')">
                <template slot-scope="props">
                  <div class="cell-center">{{ props.row.order_value || '-' }}</div>
                </template>
              </el-table-column>

              <el-table-column
                v-if="fidelitiesLabelsPrimaryOption == 'ordersNumber'"
                min-width="50"
                prop="order_numbers"
                :label="$t('marketingFidelities.ordersNumber')">
                <template slot-scope="props">
                  <div class="cell-center">{{ props.row.order_numbers || '-' }}</div>
                </template>
              </el-table-column>

              <el-table-column
                v-if="fidelitiesLabelsPrimaryOption == 'MOR'"
                min-width="50"
                prop="order_numbers"
                :label="$t('marketingFidelities.MOR')">
                <template slot-scope="props">
                  <div class="cell-center">{{ props.row.mor_value || '-' }}</div>
                </template>
              </el-table-column>

              <el-table-column
                min-width="50"
                prop="label_color"
                :label="$t('marketingFidelities.color')">
                <template slot-scope="props">
                  <div class="cell-center" :style="{ backgroundColor: props.row.color, width: '75%', color: props.row.color }">
                    {{ props.row.color }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                min-width="50"
                prop="product"
                :label="$t('marketingFidelities.product')">
                <template slot-scope="props">
                  <div class="cell-center">{{ props.row.product ? props.row.product.name : '-' }}</div>
                </template>
              </el-table-column>

              <el-table-column
                min-width="50"
                prop="coupon"
                :label="$t('marketingFidelities.coupon')">
                <template slot-scope="props">
                  <div class="cell-center">{{ props.row.coupon || '-' }}</div>
                </template>
              </el-table-column>

              <el-table-column
                :width="320"
                :label="$t('general.actions')">
                <template slot-scope="props">
                  <a
                    class="btn delete mar-rt-10"
                    :title="$t('marketingCampaigns.send')"
                    @click="handleDelete(props.row.id)">
                    <img src="/static/img/icons/icon-close.png">
                    {{$t('general.delete')}}
                  </a>
                  <div class="edit" @click="goToRecord(props.row, $event, props.row)">
                    <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import swal from 'sweetalert2'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import 'sweetalert2/dist/sweetalert2.css'

export default {
   // components: {
  //   GeneralTopBar
  // },
  created () {
    this.initPage()

    this.fidelitiesLabelsPrimaryOption = this.$session.get('selectedCompanyData').fidelities_labels_primary_option

    this.$bus.$on('refresh', this.handleRefresh)
  },
  // mounted () {
  //   this.$bus.$on('refresh', this.handleRefresh)
  // },
  beforeDestroy () {
    this.$bus.$off('refresh', this.handleRefresh)
  },
  data () {
    return {
      loading: true,
      tableData: [],
      isNew: false,
      showLocations: false,
      fidelitiesLabelsPrimaryOption: null,
      model: {
        name: '',
        orderValue: null,
        orderNumbers: null,
        color: '',
        notification: '',
        coupon: '',
        productId: null,
        recurrence: 0,
        user_notification: '',
        showError: false
      },
      colors: {
        red: '#f7786b',
        green: '#d9ecd0',
        blue: '#92a8d1',
        yellow: '#ffef96',
        orange: 'orange',
        pink: '#eca1a6',
        aqua: '#80ced6',
        navy: 'navy',
        maroon: 'maroon',
        olive: 'olive',
        white: 'white',
        grey: '#888888',
        black: 'black'
      },
      locations: [],
      products: [],
      modelValidations: {
        name: {
          required: true,
          min: 3
        },
        color: {
          required: true
        }
      },
      orderValNumOnCreate: false,
      labelsPrimaryOption: null,
      labelsInterval: null,
      fidelitiesOptions: [],
      fidelitiesIntervalOptions: [],
      fidelitiesReccurenceOptions: [],
      showLabel: null,
      enableLabelNotification: null,
      currency: null
    }
  },
  methods: {
    handleRefresh () {
      this.initPage()
    },
    initPage () {
      this.getUserLabeling()

      const companyData = this.$session.get('selectedCompanyData')
      this.locations = companyData.locations_details

      const data = {
        token: this.$session.get('token')
      }

      const companyID = this.$session.get('selectedCompany')
      const currency = companyData.price_details
      if (currency !== undefined) {
        this.currency = this.decodeHtml(currency.symbol)
      }

      // Folosim arrow function aici pentru a păstra contextul `this`
      this.apiRequest('/settings/general/' + companyID, 'GET', data, (response) => {
        if (response.status === true) {
          this.$nextTick(() => {
            this.loading = false
            this.showLabel = !!response.data[0].show_userlabel
            this.enableLabelNotification = !!response.data[0].enable_label_notification
          })
        }
      })
    },
    goToRecord (row, event, column) {
      if (typeof this.callback === 'function') {
        this.callback(row.id)
      } else {
        this.globalGoToRecord(row, event, column, '/user-label/edit/')
      }
    },
    goToAdd () {
      this.$router.push('/user-label/add')
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    getUserLabeling () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/userlabeling', 'GET', data, response => {
        if (response.status === true) {
          const dataWithError = response.data.items.map(value => ({
            ...value,
            showError: false
          }))
          this.tableData = dataWithError
          this.fidelitiesOptions = response.data.fidelities_options
          this.fidelitiesIntervalOptions = response.data.fidelities_intervals
          this.labelsInterval = response.data.fidelities_labels_interval
          this.labelsPrimaryOption = response.data.fidelities_labels_primary_option
          this.fidelitiesReccurenceOptions = response.data.fidelities_recurrences
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    saveDetails () {
      var companyID = this.$session.get('selectedCompany')
      var data = {
        'token': this.$session.get('token'),
        'fidelities_labels_primary_option': this.labelsPrimaryOption,
        'enable_label_notification': this.enableLabelNotification,
        'fidelities_labels_interval': this.labelsInterval,
        'show_userlabel': this.showLabel
      }

      var self = this
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          swal({'text': self.$t('marketingFidelities.labelingSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          self.$session.set('selectedCompanyData', self.buildCompanySessionData(response.data[0]))
          if (response.data[0]) {
            self.fidelitiesLabelsPrimaryOption = response.data[0].fidelities_labels_primary_option
          }
        } else {
          self.handleErrors(response.errors)
          // swal({'text': 'Something went wrong, please try again later...', 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
        }
      })
    },
    handleDelete (item) {
      var btnCounter = 3
      swal({
        text: this.$t('marketingFidelities.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('marketingFidelities.yes') + ' (' + btnCounter + ')'
      })
      .then((result) => {
        if (result) {
          const data = {
            id: item,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          this.apiRequest('/userlabeling/' + item, 'DELETE', data, (response) => {
            if (response.status === true) {
              swal(
                '',
                this.$t('marketingFidelities.labelDeleted'),
                'success'
              )
              this.getUserLabeling()
            } else {
              swal(
                '',
                response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
                'error'
              )
            }
          })
          // }
        }
      })
      .catch((err) => {
        if (err) {
        }
      })
      swal.disableConfirmButton()
      const yes = this.$t('general.yes')
      const btnInterval = setInterval(() => {
        btnCounter--
        if (btnCounter >= 1) {
          if (swal.getConfirmButton()) {
            swal.getConfirmButton().textContent = `${yes} (${btnCounter})`
          }
        } else {
          if (swal.getConfirmButton()) {
            swal.getConfirmButton().textContent = yes
          }
          clearInterval(btnInterval)
          swal.enableConfirmButton()
        }
      }, 1000)
    },
    validate () {
      this.errors['items'] = this.removeErrorByName('error', this.errors['items'])
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.handleCreate()
        } else {
          // console.info('is not valid', this.errors)
        }
      })
    },
    checkValueOrNumber (item) {
      if (item) {
        item.showError = false
      } else {
        this.model.showError = false
      }
    }
  }
}
</script>

<style>
td.error-spelling-fix-position textarea.label-notification-textarea {
  resize: vertical !important;
  overflow: hidden !important;
  min-height: auto !important;
}

.delivery_method{
  display: flex;
  flex-direction: column;
}
.delivery_method_points{
  display: flex;
  align-items: center;
  gap: 30px;
  margin-bottom: 10px;
}

.delivery_method_points :first-child {
  width: 300px;
}

.loyaltyPointsModal__footer {
  text-align: end;
}

.loyaltyModal {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Fidelities/UserLabel/UserLabeling.vue